export const PRICING_SECTION = {
  id: "group-access",
  tierLabel: "База",
  title: "Базовая подписка",
  subtitle:
    "Групповой доступ по числу сотрудников. Включено 10 ГБ для видео и материалов проектов — этого достаточно для старта.",
  plans: [
    {
      packageId: "biz_s_15",
      title: "Микрокоманда",
      price: 4990,
      pricePeriod: "/ мес",
      badge: "Групповой доступ",
      perUnit: "До 15 сотрудников",
      segmentLabel: "1–15 чел.",
      features: [
        "30 дней подписки",
        "10 ГБ видео на компанию",
        "Ссылка для всей команды",
        "Telegram и MAX",
      ],
      highlight: false,
    },
    {
      packageId: "biz_m_50",
      title: "Отдел",
      price: 9990,
      pricePeriod: "/ мес",
      badge: "Групповой доступ",
      perUnit: "16–50 сотрудников",
      segmentLabel: "16–50 чел.",
      features: [
        "30 дней подписки",
        "10 ГБ видео на компанию",
        "Несколько сценариев",
        "Telegram и MAX",
      ],
      highlight: true,
    },
    {
      packageId: "biz_l_100",
      title: "Компания",
      price: 14990,
      pricePeriod: "/ мес",
      badge: "Групповой доступ",
      perUnit: "51–100 сотрудников",
      segmentLabel: "51–100 чел.",
      features: [
        "30 дней подписки",
        "10 ГБ видео на компанию",
        "Программы по подразделениям",
        "Telegram и MAX",
      ],
      highlight: false,
    },
  ],
};

export const MEDIA_STORAGE_SECTION = {
  id: "media-storage",
  tierLabel: "Дополнительно",
  title: "Дополнительное место для видео",
  subtitle:
    "Если 10 ГБ базового объёма не хватает, докупите медиа-пакет. Место суммируется на аккаунте компании.",
  plans: [
    {
      packageId: "media_10",
      title: "+10 ГБ",
      price: 790,
      pricePeriod: "разово",
      perUnit: "Дополнительно к базовым 10 ГБ",
      highlight: false,
    },
    {
      packageId: "media_50",
      title: "+50 ГБ",
      price: 2490,
      pricePeriod: "разово",
      perUnit: "Выгоднее за гигабайт",
      highlight: true,
    },
    {
      packageId: "media_200",
      title: "+200 ГБ",
      price: 7990,
      pricePeriod: "разово",
      perUnit: "Для больших библиотек",
      highlight: false,
    },
  ],
};

export const PRICING_FAQ = [
  {
    question: "Как сотрудники получают доступ?",
    answer:
      "Вы оформляете подписку по размеру команды, публикуете проект и делитесь ссылкой в Telegram или MAX. Сотрудники переходят по ссылке и проходят программу без персональных ключей.",
  },
  {
    question: "Сколько сотрудников может пройти сценарий?",
    answer:
      "Лимит зависит от тарифа: до 15, до 50 или до 100 человек.",
  },
  {
    question: "Сколько места включено для видео?",
    answer:
      "На каждую компанию включено 10 ГБ для видеофайлов всех проектов. Текстовые форматы (база знаний и тренажёр без видео) обычно укладываются в этот объём. Если нужно больше — докупите медиа-пакет.",
  },
  {
    question: "Что будет при превышении лимита?",
    answer:
      "Загрузка новых видео будет недоступна, пока вы не освободите место или не докупите медиа-пакет. Уже опубликованные материалы и прохождение для команды продолжают работать.",
  },
  {
    question: "Можно ли запустить обучение без подписки?",
    answer:
      "Редактор доступен для подготовки сценария. Для публикации и группового доступа по ссылке нужна активная бизнес-подписка.",
  },
  {
    question: "Как продлевается подписка?",
    answer:
      "Автоматического списания с карты нет. За 5 дней и за 1 день до окончания периода мы напомним по email — продлите подписку в разделе «Тарифы». Если оплата не поступит вовремя, групповой доступ к сценариям будет приостановлен.",
  },
];
